import { Hospital } from "@lab/types/hospitals";
import httpClient from "@lab/api/httpClient";

export const hospital = {
	get: async (id: number): Promise<Hospital | undefined> => {
		const response = await httpClient.get(`/hospitals/${id}`);
		return response.data as Hospital;
	},
	put: async (hospital: Hospital): Promise<Hospital | undefined> => {
		const { id } = hospital;
		const response = await httpClient.put(`/hospitals/${id}`, hospital);
		return response.data;
	},
	create: async (hospital: Hospital): Promise<Hospital | undefined> => {
		const response = await httpClient.post(`/hospitals`, hospital);
		return response.data;
	},
	delete: async (id: number): Promise<undefined> => {
		const response = await httpClient.delete(`/hospitals/${id}`);
		return response.data as undefined;
	}
};
